import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { API_URL } from "constants";
import {
  Box,
  Input,
  Button,
  Text,
  VStack,
  Alert,
  AlertIcon,
  InputGroup,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

const ResetMasterPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      await axios.post(`${API_URL}/api/auth/reset-master-password`, {
        token,
        newMasterPassword: password,
      });
      setSuccess("Mot de passe réinitialisé avec succès.");
      setTimeout(() => {
        history.push("/auth/sign-in");
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Une erreur est survenue lors de la réinitialisation du mot de passe.");
    }
  };

  const handleBlurPassword = () => {
    if (password.length < 8) {
      setPasswordError("Le mot de passe doit contenir au moins 8 caractères.");
    } else {
      setPasswordError("");
    }
  };

  const handleBlurConfirmPassword = () => {
    if (password !== confirmPassword) {
      setConfirmPasswordError("Les mots de passe ne correspondent pas.");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (value.length >= 8) {
      setPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    if (value === password) {
      setConfirmPasswordError("");
    }
  };

  const isPasswordValid = password.length >= 8;
  const doPasswordsMatch = password === confirmPassword;

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh" px={4}>
      <VStack spacing={4} align="center" width="100%">
        <Text fontSize="2xl" fontWeight="bold" color="teal.500">
          Réinitialiser le mot de passe maître
        </Text>
        <Text fontSize="md" color="gray.600" textAlign="center">
          Veuillez entrer un nouveau mot de passe maître et le confirmer.
        </Text>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <VStack spacing={4} align="center">
            <InputGroup width="50%">
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="Nouveau mot de passe"
                value={password}
                onChange={handlePasswordChange}
                onBlur={handleBlurPassword}
                isRequired
              />
              <InputRightElement>
                <IconButton
                  icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                  onClick={() => setShowPassword(!showPassword)}
                  variant="ghost"
                  aria-label="Toggle Password Visibility"
                />
              </InputRightElement>
            </InputGroup>
            {passwordError && (
              <Text color="red.500" fontSize="sm" textAlign="left" width="50%">
                {passwordError}
              </Text>
            )}
            <InputGroup width="50%">
              <Input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirmer le mot de passe"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                onBlur={handleBlurConfirmPassword}
                isRequired
              />
              <InputRightElement>
                <IconButton
                  icon={showConfirmPassword ? <ViewOffIcon /> : <ViewIcon />}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  variant="ghost"
                  aria-label="Toggle Confirm Password Visibility"
                />
              </InputRightElement>
            </InputGroup>
            {confirmPasswordError && (
              <Text color="red.500" fontSize="sm" textAlign="left" width="50%">
                {confirmPasswordError}
              </Text>
            )}
            <Button
              type="submit"
              colorScheme="teal"
              isDisabled={!isPasswordValid || !doPasswordsMatch}
              onClick={() => {
                if (!isPasswordValid) setPasswordError("Le mot de passe doit contenir au moins 8 caractères.");
                if (!doPasswordsMatch) setConfirmPasswordError("Les mots de passe ne correspondent pas.");
              }}
            >
              Réinitialiser
            </Button>
          </VStack>
        </form>
        {success && (
          <Alert status="success" width="50%">
            <AlertIcon />
            {success}
          </Alert>
        )}
        {error && (
          <Alert status="error" width="50%">
            <AlertIcon />
            {error}
          </Alert>
        )}
      </VStack>
    </Box>
  );
};

export default ResetMasterPassword;
